export default {
  sm: `
  World-class Security
  Technology 
  Protecting NAVER    
  `,
  md: `
  World-class Security
  Technology Protecting 
  NAVER    
  `,
  lg: `
  World-class Security
  Technology Protecting NAVER    
  `,
  xxl: `
  World-class Security 
  Technology
  Protecting NAVER    
  `,
};
